if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent = this.querySelector(
          '[id^="QuickAddInfo-"]'
        );

        this.addEventListener(
          'product-info:loaded',
          ({ target }) => {
            target.addPreProcessCallback(
              this.preprocessHTML.bind(this)
            );
          }
        );
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        /*
         * 一覧側で直接出力しているブランド用HTMLは残す。
         * 通常のQuick Addだけ、閉じる際に中身を空にする。
         */
        const brandQuickAdd =
          this.modalContent.querySelector(
            '[data-brand-quick-add]'
          );

        if (!brandQuickAdd) {
          this.modalContent.innerHTML = '';
        }

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');

        const spinner = opener.querySelector(
          '.loading__spinner'
        );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        /*
         * card-product.liquid内にブランド用HTMLが
         * 直接出力されている場合はfetchせず、そのまま表示する。
         */
        const brandQuickAdd =
          this.modalContent.querySelector(
            '[data-brand-quick-add]'
          );

        if (brandQuickAdd) {
          this.initializeBrandQuickAdd();

          super.show(opener);

          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');

          if (spinner) {
            spinner.classList.add('hidden');
          }

          return;
        }

        /*
         * ブランド用HTMLがない通常商品は、
         * 従来どおり商品ページを取得して表示する。
         */
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `商品情報の取得に失敗しました: ${response.status}`
              );
            }

            return response.text();
          })
          .then((responseText) => {
            const responseHTML =
              new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

            const productElement =
              responseHTML.querySelector('product-info');

            if (!productElement) {
              throw new Error(
                '商品情報が見つかりませんでした。'
              );
            }

            this.preprocessHTML(productElement);

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            if (
              window.Shopify &&
              Shopify.PaymentButton
            ) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            super.show(opener);
          })
          .catch((error) => {
            console.error('[Quick Add]', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      initializeBrandQuickAdd() {
        const brandQuickAdd =
          this.modalContent.querySelector(
            '[data-brand-quick-add]'
          );

        if (!brandQuickAdd) return;

        /*
         * 同じモーダルを再度開いたときに、
         * イベントを重複登録しない。
         */
        if (brandQuickAdd.dataset.initialized === 'true') {
          return;
        }

        brandQuickAdd.dataset.initialized = 'true';

        const mainImage = brandQuickAdd.querySelector(
          '[data-brand-quick-add-main-image]'
        );

        /*
         * カラー画像をクリックしたとき、
         * 左側のメイン画像を切り替える。
         */
        brandQuickAdd
          .querySelectorAll(
            '[data-brand-quick-add-image-button]'
          )
          .forEach((button) => {
            button.addEventListener('click', () => {
              if (!mainImage) return;

              const imageSrc =
                button.dataset.imageSrc;

              if (!imageSrc) return;

              mainImage.src = imageSrc;
              mainImage.removeAttribute('srcset');

              brandQuickAdd
                .querySelectorAll(
                  '[data-brand-quick-add-image-button]'
                )
                .forEach((otherButton) => {
                  otherButton.classList.remove(
                    'is-active'
                  );
                });

              button.classList.add('is-active');
            });
          });

        /*
         * 最初のカラー画像を選択状態にする。
         */
        const firstImageButton =
          brandQuickAdd.querySelector(
            '[data-brand-quick-add-image-button]'
          );

        if (firstImageButton) {
          firstImageButton.classList.add('is-active');
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach(
          (classApplied) => {
            if (
              classApplied.startsWith('color-') ||
              classApplied === 'gradient'
            ) {
              this.modalContent.classList.add(
                classApplied
              );
            }
          }
        );

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(
          productElement
        );
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute(
          'data-update-url',
          'false'
        );
      }

      removeDOMElements(productElement) {
        const pickupAvailability =
          productElement.querySelector(
            'pickup-availability'
          );

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          productElement.querySelector(
            'product-modal'
          );

        if (productModal) {
          productModal.remove();
        }

        const modalDialogs =
          productElement.querySelectorAll(
            'modal-dialog'
          );

        modalDialogs.forEach((modal) => {
          modal.remove();
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId =
          productElement.dataset.section;

        if (!sectionId) return;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML =
          productElement.innerHTML.replaceAll(
            oldId,
            newId
          );

        Array.from(
          productElement.attributes
        ).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(
                oldId,
                newId
              )
            );
          }
        });

        productElement.dataset.originalSection =
          sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList =
          productElement.querySelector(
            '[id^="Slider-Gallery"]'
          );

        if (!galleryList) return;

        galleryList.setAttribute(
          'role',
          'presentation'
        );

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => {
            item.setAttribute(
              'role',
              'presentation'
            );
          });
      }

      updateImageSizes(productElement) {
        const product =
          productElement.querySelector('.product');

        const desktopColumns =
          product?.classList.contains(
            'product--columns'
          );

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll(
            '.product__media img'
          );

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, ' +
          '(min-width: 750px) calc((100vw - 11.5rem) / 2), ' +
          'calc(100vw - 4rem)';

        if (
          product.classList.contains(
            'product--medium'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '605px'
            );
        } else if (
          product.classList.contains(
            'product--small'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '495px'
            );
        }

        mediaImages.forEach((image) => {
          image.setAttribute(
            'sizes',
            mediaImageSizes
          );
        });
      }
    }
  );
}

/* ==============================
  Brand Quick Add：Swymお気に入り
============================== */

function brandQuickAddWithSwym(callback) {
  if (window._swat) {
    callback(window._swat);
    return;
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(callback);
}

function updateBrandQuickAddWishlistButtons(productId, variantId, isAdded) {
  document
    .querySelectorAll('[data-brand-quick-add-wishlist]')
    .forEach(function (button) {
      if (
        Number(button.dataset.productId) !== Number(productId) ||
        Number(button.dataset.variantId) !== Number(variantId)
      ) {
        return;
      }

      button.classList.toggle('is-added', isAdded);
      button.setAttribute('aria-pressed', isAdded ? 'true' : 'false');

      const icon = button.querySelector('[aria-hidden="true"]');

      if (icon) {
        icon.textContent = isAdded ? '♥' : '♡';
      }
    });
}

document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '[data-brand-quick-add-wishlist]'
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productId = Number(button.dataset.productId);
  const variantId = Number(button.dataset.variantId);
  const productUrl = button.dataset.productUrl;

  if (!productId || !variantId || !productUrl) {
    console.warn('お気に入り登録に必要な情報が不足しています。', {
      productId,
      variantId,
      productUrl
    });
    return;
  }

  const productData = {
    empi: productId,
    epi: variantId,
    du: productUrl
  };

  button.disabled = true;

  brandQuickAddWithSwym(function (swat) {
    const isAdded = button.classList.contains('is-added');

    const onSuccess = function () {
      updateBrandQuickAddWishlistButtons(
        productId,
        variantId,
        !isAdded
      );

      button.disabled = false;
    };

    const onError = function (error) {
      console.error('Swymお気に入り処理に失敗しました。', error);
      button.disabled = false;
    };

    if (isAdded) {
      swat.removeFromWishList(
        productData,
        onSuccess,
        onError
      );
    } else {
      swat.addToWishList(
        productData,
        onSuccess,
        onError
      );
    }
  });
});

function markBrandQuickAddWishlistButtons() {
  const buttons = document.querySelectorAll(
    '[data-brand-quick-add-wishlist]'
  );

  if (!buttons.length) return;

  brandQuickAddWithSwym(function (swat) {
    swat.fetch(
      function (products) {
        buttons.forEach(function (button) {
          const productId = Number(button.dataset.productId);
          const variantId = Number(button.dataset.variantId);

          const isAdded = products.some(function (item) {
            return (
              Number(item.empi) === productId &&
              Number(item.epi) === variantId
            );
          });

          updateBrandQuickAddWishlistButtons(
            productId,
            variantId,
            isAdded
          );
        });
      },
      function (error) {
        console.error(
          'Swymお気に入り状態を取得できませんでした。',
          error
        );
      }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    markBrandQuickAddWishlistButtons
  );
} else {
  markBrandQuickAddWishlistButtons();
}